'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { Button } from '@workspace/ui/components/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@workspace/ui/components/dialog';
import { X } from 'lucide-react';
import Image from 'next/image';

interface CardOrderSuccessDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function CardOrderSuccessDialog({ open, onOpenChange }: CardOrderSuccessDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="md" className="[&>.dialog-scrollbar]:overflow-y-auto" hideCloseButton>
        <DialogHeader className="sr-only">
          <DialogTitle>Your card is on its way</DialogTitle>
        </DialogHeader>
        <div className="flex w-full justify-end">
          <DialogClose asChild>
            <Button
              type="button"
              variant="primary-icon"
              className="[&[data-variant*=icon]]:h-8 [&[data-variant*=icon]]:w-8 [&[data-variant*=icon]_svg]:h-[24px] [&[data-variant*=icon]_svg]:w-[24px]"
            >
              <X />
              <p className="sr-only">Close</p>
            </Button>
          </DialogClose>
        </div>
        <div className="-mt-2 flex w-full flex-col gap-5">
          <div className="flex w-full flex-col gap-4">
            <p className="text-neutral-200 dark:text-neutral-100 text-[32px] leading-10 font-bold">
              Your card is on its way
            </p>
            <p className="text-grey-900 dark:text-grey-400 text-lg leading-6">
              Your Native Teams card has been successfully ordered and is now on its way to you.
            </p>
          </div>
          <div className="bg-grey-0 dark:bg-grey-900 relative aspect-[512/286] w-full overflow-hidden rounded-[20px]">
            <div className="card-on-way-road border-grey-200 dark:border-grey-700 absolute top-[52%] -right-[10%] -left-[10%] border-t-2 border-dashed" />
            <div className="card-on-way-float absolute top-1/2 left-1/2 z-10 w-[45%]">
              <Image
                src="https://i.nativeteams.com/assets/app/wallet/cards/nt-card.png"
                alt="Native Teams card"
                width={566}
                height={357}
                className="h-auto w-full rounded-xl shadow-[0_18px_34px_rgba(42,43,65,0.18)]"
              />
            </div>
            <span className="card-on-way-dot absolute top-[26%] left-[8%] size-2 rounded-full bg-pink-400" />
            <span className="card-on-way-dot card-on-way-dot-delayed absolute top-[70%] left-[8%] size-1.5 rounded-full bg-pink-400" />
          </div>
        </div>
        <Button variant="primary" className="mt-3 w-full" onClick={() => onOpenChange(false)}>
          Close
        </Button>
      </DialogContent>
    </Dialog>
  );
}
